<template>
    <va-create-layout>
        <SolutionProviderCreditEvent-form
            :title="title"
            :item="item"
        ></SolutionProviderCreditEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
